import { IELTData } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import React, { useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { LoaderOverlay } from 'core-components/library/loader'
import { Controller } from 'core-components/library/validation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { Title } from '../../styledComponents/title/Title'

import { deleteVersion } from './api/deleteVersion'

import styles from './DeleteVersionContent.module.scss'

interface IProps {
  selectedVersion: IELTData
  closeDialog: () => void
}

export const DeleteVersionContent = ({ selectedVersion, closeDialog }: IProps) => {
  const [wip, setWip] = useState(false)

  const onDelete = async () => {
    setWip(true)
    await deleteVersion(selectedVersion.EntryId)
    setWip(false)
    closeDialog()
  }

  return (
    <Controller>
      <div className={styles.root}>
        <LoaderOverlay show={wip} />
        <Title align={'center'} text={getFormedEltTranslation('delete-version')} />
        <Translation text={getFormedEltTranslation('delete-confirm')} />
        <div className={styles.btnWrapper}>
          <Button onClick={onDelete}>
            <Translation text={getFormedEltTranslation('delete')} />
          </Button>
        </div>
      </div>
    </Controller>
  )
}
